import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';
import { ERROR_ROUTE, SURVEY_EXPIRED_ROUTE, SURVEY_RESULT_ROUTE } from '../constants/routes';
import { useSurveyRoutes } from './useSurveyRoutes';
import { useRouter } from './useRouter';
import { selectHasMetSurveyRequirements } from '../redux/selectors/survey_selectors';
import { useAppSelector } from '../redux/ReduxProvider';

export const useSurveyGuard = () => {
  const { routes, surveyCode } = useSurveyRoutes();
  const { goTo } = useRouter({ keepQueryParams: true });
  const match = useMatch(routes.survey);
  const canSubmitSurvey = useAppSelector(selectHasMetSurveyRequirements);

  const { error, isSubmitted, isExpired, canViewResults } = useAppSelector((state) => state.survey);

  useEffect(() => {
    if (error) {
      goTo(ERROR_ROUTE);
    } else if (isSubmitted) {
      goTo(canViewResults ? SURVEY_RESULT_ROUTE : routes.thankYou, [surveyCode]);
    } else if (isExpired) {
      goTo(SURVEY_EXPIRED_ROUTE, [surveyCode]);
    } else if (!isSubmitted && !match && !canSubmitSurvey) {
      goTo(routes.survey, [surveyCode]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, isSubmitted, isExpired, surveyCode, match?.pathname, canSubmitSurvey, canViewResults]);
};
